import { RobotType } from '@mygpt/app/datasets/services';

export const isAgentRobot = (robotType: RobotType | string | undefined): boolean => {
  return robotType?.includes('agent') ?? false;
};

/**
 * 检查是否是新版本agent类型（使用AgentMessage渲染）
 * 任何包含下划线的agent类型（如 general_agent, catalog_agent 等）都使用AgentMessage
 * 单纯的 "agent" 或其他类型使用原本的渲染方式
 */
export const isNewAgentType = (robotType: RobotType | string | undefined): boolean => {
  if (!robotType) return false;
  // 检查是否包含'agent'且有前缀（即包含下划线）
  return robotType.includes('agent') && robotType.includes('_');
};
